import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const ListContainer = styled.div`
  label {
    font-size: inherit;
  }
`;

export const SubListGeo = styled.div<{
  'data-testid'?: string;
}>`
  a {
    border-bottom: none;
    padding: 0 0;
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-right: ${primitive.$spacing1};
  align-items: center;
  color: ${p => p.theme.token('text-default')};
`;

export const LocationContainer = styled.div`
  align-items: center;
  color: ${p => p.theme.token('text-default')};
  display: flex;
  margin: 0 ${primitive.$spacing2} 0 0;
`;
